module.exports = {
    "baseUrl": "https://api-v4.staging.primrose.health",
    "clinicBaseUrl": "https://api-v4.staging.primrose.health",
    "systemName": "System dev"
}